import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { adminReviewsApi } from 'src/api';

import { setAdminReviewErrors, setAdminReviewsMeta } from './adminReviews.slice';

import { normalizeErrorResponse } from 'src/utils';

export const getAdminReviews = createAsyncThunk(
  'adminReviews/get-admin-reviews',
  async (data, thunkApi) => {
    try {
      const copiedPayload = _.cloneDeep(data);

      for (const key in copiedPayload) {
        if (!copiedPayload[key]?.length) {
          delete copiedPayload[key];
        }
      }

      const response = await adminReviewsApi.getAdminReviews(copiedPayload);

      thunkApi.dispatch(setAdminReviewsMeta(response?.meta));

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const getAdminEditReview = createAsyncThunk(
  'adminReviews/get-admin-edit-review',
  async (data) => {
    try {
      const response = await adminReviewsApi.getAdminEditReview(data);

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateAdminReview = createAsyncThunk(
  'adminReviews/update-admin-review',
  async (data, thunkApi) => {
    try {
      const { id, payload } = data; // navigate

      const copiedPayload = _.cloneDeep(payload);

      for (const key in copiedPayload) {
        if (
          !copiedPayload[key]?.length &&
          typeof copiedPayload[key] !== 'object' &&
          typeof copiedPayload[key] !== 'boolean'
        ) {
          delete copiedPayload[key];
        }
      }

      delete copiedPayload?.created_at;
      copiedPayload.active = copiedPayload.active ? 1 : 0;

      const response = await adminReviewsApi.updateAdminReview(id, copiedPayload);

      toast(response.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setAdminReviewErrors(normalizeErrorResponse(response.data.errors)));
    }
  },
);
